import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { updateAccount, createAccount } from "../../slices/accounts";
import { useNavigate } from 'react-router-dom';

const AccountForm = ({ account }) => {

    let timer = null;

    const dispatch = useDispatch()
    const [isEditing, setIsEditing] = useState(false)


    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors, isDirty }
    } = useForm({
        defaultValues: {
            name: account.name,
            address_1: account.address_1,
            address_2: account.address_2,
            zip_code: account.zip_code,
            city: account.city,
            country: account.country,
            vat: account.vat,
            email: account.email,
            phone: account.phone,
            ssn: account.ssn,
            send_email: account.send_email,
            send_renewal_receipt: account.send_renewal_receipt,
            admin_send_new_subscription_email: account.admin_send_new_subscription_email,
            admin_send_renewal_email: account.admin_send_renewal_email,
            admin_send_renewal_failure_email: account.admin_send_renewal_failure_email,
            admin_send_cancel_email: account.admin_send_cancel_email,
            admin_send_cancel_failed_payment_email: account.admin_send_cancel_failed_payment_email,
            admin_send_billing_period_failed_email: account.admin_send_billing_period_failed_email,
            admin_send_payment_method_update_email: account.admin_send_payment_method_update_email,
            admin_send_payment_method_expiring_warning_email: account.admin_send_payment_method_expiring_warning_email,
        }
    });

    useEffect(() => {
        if (isDirty) {
            setIsEditing(true)
        }
    }, [isDirty])

    const onSubmit = (data) => {
        Promise.resolve(dispatch(updateAccount({ id: account.id, args: data })))
            .then(() => {
                setIsEditing(false)
            })
    }

    useEffect(() => {
        if (account) {
            reset({
                ...account
            })
        }
    }, [account])


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4">
                            <label>{gettext('Name')}</label>
                            <input type="text" {...register("name")} className="form-control" />
                        </div>
                        <div className="col-6 mb-4">
                            <label>{gettext('Address')}</label>
                            <input type="text" {...register("address_1")} className="form-control" />
                        </div>
                        <div className="col-6 mb-4">
                            <label>{gettext('Address 2')}</label>
                            <input type="text" {...register("address_2")} className="form-control" />
                        </div>
                        <div className="col-4 mb-4">
                            <label>{gettext('Zip code')}</label>
                            <input type="text" {...register("zip_code")} className="form-control" />
                        </div>
                        <div className="col-4 mb-4">
                            <label>{gettext('City')}</label>
                            <input type="text" {...register("city")} className="form-control" />
                        </div>
                        <div className="col-4 mb-4">
                            <label>{gettext('Country')}</label>
                            <input type="text" {...register("country")} className="form-control" />
                        </div>
                        <div className="col-6 mb-4">
                            <label>{gettext('SSN')}</label>
                            <input type="text" {...register("ssn")} className="form-control" />
                        </div>
                        <div className="col-6 mb-4">
                            <label>{gettext('Vat number')}</label>
                            <input type="text" {...register("vat")} className="form-control" />
                        </div>
                        <div className="col-6 mb-4">
                            <label>{gettext('Email')}</label>
                            <input type="text" {...register("email")} className="form-control" />
                        </div>
                        <div className="col-6 mb-4">
                            <label>{gettext('Phone')}</label>
                            <input type="text" {...register("phone")} className="form-control" />
                        </div>
                        <div className="col-12 mb-4">
                            <label>{gettext('Various email settings')}</label>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("send_email")} type="checkbox" role="switch" id="send_email" />
                                <label className="form-check-label" htmlFor="send_email">{gettext("Send email to customers on renewal")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("send_renewal_receipt")} type="checkbox" role="switch" id="send_renewal_receipt" />
                                <label className="form-check-label" htmlFor="send_renewal_receipt">{gettext("Attach PDF receipt to renewal emails")}</label>
                            </div>
                        </div>
                        <div className="col-12 mb-4">
                            <label>{gettext('Send admin a copy of email sent to customer when:')}</label>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_new_subscription_email")} type="checkbox" role="switch" id="admin_send_new_subscription_email" />
                                <label className="form-check-label" htmlFor="admin_send_new_subscription_email">{gettext("New subscription is bought")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_renewal_email")} type="checkbox" role="switch" id="admin_send_renewal_email" />
                                <label className="form-check-label" htmlFor="admin_send_renewal_email">{gettext("Subscription is renewed")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_renewal_failure_email")} type="checkbox" role="switch" id="admin_send_renewal_failure_email" />
                                <label className="form-check-label" htmlFor="admin_send_renewal_failure_email">{gettext("Subscription fails to be renewed")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_cancel_email")} type="checkbox" role="switch" id="admin_send_cancel_email" />
                                <label className="form-check-label" htmlFor="admin_send_cancel_email">{gettext("Subscription is cancelled")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_cancel_failed_payment_email")} type="checkbox" role="switch" id="admin_send_cancel_failed_payment_email" />
                                <label className="form-check-label" htmlFor="admin_send_cancel_failed_payment_email">{gettext("Subscription is cancelled due to failed payments")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_billing_period_failed_email")} type="checkbox" role="switch" id="admin_send_billing_period_failed_email" />
                                <label className="form-check-label" htmlFor="admin_send_billing_period_failed_email">{gettext("Subscription renewal has failed 3x within billing cycle")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_payment_method_update_email")} type="checkbox" role="switch" id="admin_send_payment_method_update_email" />
                                <label className="form-check-label" htmlFor="admin_send_payment_method_update_email">{gettext("Payment method is updated")}</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" {...register("admin_send_payment_method_expiring_warning_email")} type="checkbox" role="switch" id="admin_send_payment_method_expiring_warning_email" />
                                <label className="form-check-label" htmlFor="admin_send_payment_method_expiring_warning_email">{gettext("Customer card has expired")}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                {isEditing &&
                    <div className="clamped text-end">
                        <input className="btn btn-primary mt-4 ms-auto" type="submit" value={gettext("Save")} />
                    </div>
                }
        </form>
    )
}

export default AccountForm